import {v4 as guid} from 'uuid';
import * as requestFromServer from './customersCrud';
import {callTypes, customersSlice} from './customersSlice';
import * as actionsGlobal from '../../_common/actions/globalMessage/showGlobalMessage';
import {messages as M} from '../../../../_metronic/i18n/messages';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {subjects as S} from '../../_common/constants/subjects';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {logMessages as L} from '../../_common/constants/logMessages';

export const getCustomersListIDPrefix = 'getCustomersList';
const {actions} = customersSlice;

const getCustomersList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getCustomersListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .findCustomers(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalCustomersCount, customersList, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalUsersCount: totalCustomersCount,
        pageCount,
        entities: customersList
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find customers';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const exportCustomersFile = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getCustomersFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data?.customersList;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const addEditCommission = (customerID, commission) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));
  return requestFromServer
    .addEditCommission(customerID, commission)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.CUSTOMERS,
        S.CUSTOMER,
        T.EDIT,
        L.CUSTOMERS_EDIT_COMMISSION(customerID, commission),
        errorCode
      );
      if (errorCode === 0) {
        dispatch(actions.addEditCommission({customerID, commission}));
        dispatch(actionsGlobal.showGlobalMessage(M.OPERATION_COMPLETED));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t send data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const updateCustomerData = (customerID, values) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));
  const {phoneNumbers, idNumber, allowInvoiceDealValue, ...rest} = values;
  const editedPhoneNumbers = Boolean(phoneNumbers) ? phoneNumbers.trim().split(',') : [];
  const data = {
    customerID,
    data: {
      phoneNumbers: editedPhoneNumbers,
      ...rest
    }
  };

  return requestFromServer
    .updateCustomerData(data)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.CUSTOMERS,
        S.CUSTOMER,
        T.EDIT,
        L.CUSTOMERS_EDIT_CUSTOMER_DATA(customerID, values?.email),
        errorCode
      );
      if (errorCode === 0 || errorCode === -5) {
        dispatch(actions.updateCustomerData(data));
      }

      if (errorCode === 0) {
        dispatch(actionsGlobal.showGlobalMessage(M.OPERATION_COMPLETED));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t send data!';
      const errorMessage = M.EDIT_FAILED;
      dispatch(actionsGlobal.showGlobalMessage(errorMessage));
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const getCustomers = getCustomersList(actions.customersFetched);
export const getNextCustomers = getCustomersList(actions.customersAppended);
